"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.PhotoApproval = exports.NameApproval = exports.StatusEnum = exports.ActionEnum = exports.ApprovalStatus = void 0;
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["NO_PENDING"] = "NO_PENDING";
    ApprovalStatus["PENDING"] = "PENDING";
    ApprovalStatus["APPROVED"] = "APPROVED";
    ApprovalStatus["DECLINED"] = "DECLINED";
})(ApprovalStatus = exports.ApprovalStatus || (exports.ApprovalStatus = {}));
var ActionEnum;
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
    ActionEnum["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    ActionEnum["APPROVED_PHOTO"] = "APPROVED_PHOTO";
    ActionEnum["APPROVED_NAMES"] = "APPROVED_NAMES";
    ActionEnum["REJECTED_PHOTO"] = "REJECTED_PHOTO";
    ActionEnum["REJECTED_NAMES"] = "REJECTED_NAMES";
    ActionEnum["DELETED_PHOTO"] = "DELETED_PHOTO";
    ActionEnum["UPDATED"] = "UPDATED";
    ActionEnum["CARD_UPDATED"] = "CARD_UPDATED";
    ActionEnum["PRODUCT_MARKETING_UPDATED"] = "PRODUCT_MARKETING_UPDATED";
    ActionEnum["SITENAME_UPDATED"] = "SITENAME_UPDATED";
    ActionEnum["MARKETING_PAGES_UPDATED"] = "MARKETING_PAGES_UPDATED";
    ActionEnum["CHANGE_IDENTITYID"] = "CHANGE_IDENTITYID";
    ActionEnum["SUSPEND"] = "SUSPEND";
    ActionEnum["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
})(ActionEnum = exports.ActionEnum || (exports.ActionEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
    StatusEnum["SUSPENDED"] = "SUSPENDED";
    StatusEnum["NEEDS_REVIEW"] = "NEEDS_REVIEW";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var NameApproval;
(function (NameApproval) {
    NameApproval["APPROVED"] = "APPROVED";
    NameApproval["REJECTED"] = "REJECTED";
})(NameApproval = exports.NameApproval || (exports.NameApproval = {}));
var PhotoApproval;
(function (PhotoApproval) {
    PhotoApproval["APPROVED"] = "APPROVED";
    PhotoApproval["REJECTED"] = "REJECTED";
})(PhotoApproval = exports.PhotoApproval || (exports.PhotoApproval = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://channels-associates.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Channels Associates Service Api
 * @version v1
 * @baseUrl https://channels-associates.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v2 = {
            /**
             * @description No JWTs required
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingGetById
             * @summary No auth required
             * @request GET:/v2/associateMarketing/{id}
             * @secure
             */
            associateMarketingGetById: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description No JWTs required
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingGetByOwnerId
             * @summary No auth required
             * @request GET:/v2/associateAgreements/{associateAgreementId}/associateMarketing
             * @secure
             */
            associateMarketingGetByOwnerId: (associateAgreementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateAgreements/${associateAgreementId}/associateMarketing`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateCard
             * @summary User or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/updateCard
             * @secure
             */
            associateMarketingUpdateCard: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateCard`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdatePendingCard
             * @summary Internal or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/updatePendingCard
             * @secure
             */
            associateMarketingUpdatePendingCard: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updatePendingCard`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingDeleteAvatarUrl
             * @summary User or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/deleteAvatarUrl
             * @secure
             */
            associateMarketingDeleteAvatarUrl: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/deleteAvatarUrl`, method: 'PUT', secure: true, format: 'json' }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingActivate
             * @summary Internal or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/activate
             * @secure
             */
            associateMarketingActivate: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingCancel
             * @summary Internal or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/cancel
             * @secure
             */
            associateMarketingCancel: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/cancel`, method: 'POST', secure: true }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingSuspend
             * @summary Internal or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/suspend
             * @secure
             */
            associateMarketingSuspend: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingNeedsReview
             * @summary Internal or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/needsReview
             * @secure
             */
            associateMarketingNeedsReview: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/needsReview`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user, internal, or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateProductMarketing
             * @summary User, Internal, or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateProductMarketing
             * @secure
             */
            associateMarketingUpdateProductMarketing: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateProductMarketing`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user, internal, or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateMarketingPages
             * @summary User, Internal, or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateMarketingPages
             * @secure
             */
            associateMarketingUpdateMarketingPages: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateMarketingPages`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateSitename
             * @summary User or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateSitename
             * @secure
             */
            associateMarketingUpdateSitename: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateSitename`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingChangeIdentityId
             * @summary User or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/changeIdentityId
             * @secure
             */
            associateMarketingChangeIdentityId: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/changeIdentityId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * No description
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourcesByOwnerAll
             * @request GET:/v1/channelsAssociates/owner/{channelsAssociateOwnerId}
             * @secure
             */
            channelsAssociatesGetResourcesByOwnerAll: (channelsAssociateOwnerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/owner/${channelsAssociateOwnerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourcesByOwner
             * @request GET:/v1/identities/{identityId}/channelsAssociates/owner/{channelsAssociateOwnerId}
             * @secure
             */
            channelsAssociatesGetResourcesByOwner: (channelsAssociateOwnerId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/owner/${channelsAssociateOwnerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetByAssociateNumberAll
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/channelsAssociates/getByAssociateNumber/{associateNumber}
             * @secure
             */
            channelsAssociatesGetByAssociateNumberAll: (associateNumber, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/getByAssociateNumber/${associateNumber}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetByAssociateNumber
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/identities/{identityId}/channelsAssociates/getByAssociateNumber/{associateNumber}
             * @secure
             */
            channelsAssociatesGetByAssociateNumber: (associateNumber, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/getByAssociateNumber/${associateNumber}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description No JWTs required
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetBySitename
             * @summary No auth required
             * @request GET:/v1/channelsAssociates/getBySitename
             * @secure
             */
            channelsAssociatesGetBySitename: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/getBySitename`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourceById
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/channelsAssociates/{associateId}
             * @secure
             */
            channelsAssociatesGetResourceById: (associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourceById2
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/identities/{identityId}/channelsAssociates/{associateId}
             * @secure
             */
            channelsAssociatesGetResourceById2: (associateId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesCreateResource
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates
             * @secure
             */
            channelsAssociatesCreateResource: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateStatus
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdateStatus: (identityId, channelsAssociateId, newStatus, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/updateStatus/${newStatus}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateResource
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}
             * @secure
             */
            channelsAssociatesUpdateResource: (channelsAssociateId, identityId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}`, method: 'PUT', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesDeleteResource
             * @summary User Match or Machine JWT Only
             * @request DELETE:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}
             * @secure
             */
            channelsAssociatesDeleteResource: (identityId, channelsAssociateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description Requires user match, internal match, or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateNamesApproval
             * @summary User Match, Internal Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/approvals/names/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdateNamesApproval: (channelsAssociateId, newStatus, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/approvals/names/updateStatus/${newStatus}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match, internal match, or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdatePhotoApproval
             * @summary User Match, Internal Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/approvals/photo/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdatePhotoApproval: (channelsAssociateId, newStatus, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/approvals/photo/updateStatus/${newStatus}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateDisplayPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/updateDisplayPhoto
             * @secure
             */
            channelsAssociatesUpdateDisplayPhoto: (channelsAssociateId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/updateDisplayPhoto`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesDeleteDisplayPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/deleteDisplayPhoto
             * @secure
             */
            channelsAssociatesDeleteDisplayPhoto: (channelsAssociateId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/deleteDisplayPhoto`, method: 'PUT', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesChangeOwner
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/changeOwner
             * @secure
             */
            channelsAssociatesChangeOwner: (identityId, channelsAssociateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUploadPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/uploadPhoto
             * @secure
             */
            channelsAssociatesUploadPhoto: (identityId, channelsAssociateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/uploadPhoto`, method: 'PUT', body: data, secure: true, type: FecContentType.FormData }, params)),
            /**
             * @description Requires user match JWT
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateDisplayMarketingInformation
             * @summary User Match Only
             * @request PUT:/v1/identities/{identityId}/associateMarketing/{associateMarketingId}/updateDisplayMarketingInformation
             * @secure
             */
            channelsAssociatesUpdateDisplayMarketingInformation: (associateMarketingId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateMarketing/${associateMarketingId}/updateDisplayMarketingInformation`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociatesJournal
             * @name ChannelsAssociatesJournalGetJournalChanges
             * @request GET:/v1/channelsAssociates/journal
             * @secure
             */
            channelsAssociatesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociatesJournal
             * @name ChannelsAssociatesJournalGetJournalMaxClock
             * @request GET:/v1/channelsAssociates/maxClock
             * @secure
             */
            channelsAssociatesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=channels-associates.js.map